import { isBenignMapsTeardownError } from '@/lib/maps/maps-teardown-errors';

import { ensurePostHog } from './posthog-client';

/**
 * Report a handled React/router error to PostHog exception tracking.
 * No-ops when analytics is off or the error is known Maps teardown noise.
 */
export function captureAppException(error: unknown): void {
  if (isBenignMapsTeardownError(error)) return;
  void ensurePostHog()
    .then((posthog) => {
      if (!posthog) return;
      if (error instanceof Error) {
        posthog.captureException(error);
        return;
      }
      posthog.captureException(new Error(typeof error === 'string' ? error : 'Non-Error throw'));
    })
    .catch(() => undefined);
}
